import { clsx } from 'clsx';

import { LineSkeleton } from '@monoimin/atoms';

import { REAL_ESTATE_LIST_CLASSES } from '../constants';

import { RealEstateCardVariant } from '../types';

import { RealEstateCardSkeleton } from './RealEstateCardSkeleton';

export const RealEstateListLoader = ({
  cardVariant,
  containerClassName,
}: {
  cardVariant: RealEstateCardVariant;
  containerClassName?: string;
}) => {
  return (
    <div
      className={clsx(REAL_ESTATE_LIST_CLASSES.container, containerClassName)}
    >
      <div className={REAL_ESTATE_LIST_CLASSES.sortingContainer}>
        <LineSkeleton variant='h2' className='mt-2 w-4/12' />
      </div>
      <div className={REAL_ESTATE_LIST_CLASSES.cardsContainer[cardVariant]}>
        {Array.from(Array(10).keys()).map((el) => (
          <RealEstateCardSkeleton key={`card-skeleton-${el}`} />
        ))}
      </div>
    </div>
  );
};
